function rectangleKeys(rows, dates, start, end) {
    if (!start || !end) return [];
    const a = rows.indexOf(String(start.lineId));
    const b = rows.indexOf(String(end.lineId));
    const x = dates.indexOf(start.date);
    const y = dates.indexOf(end.date);
    if ([a, b, x, y].some(index => index < 0)) return [];
    const keys = [];
    for (let row = Math.min(a, b); row <= Math.max(a, b); row += 1) {
        for (let column = Math.min(x, y); column <= Math.max(x, y); column += 1) keys.push(`${rows[row]}:${dates[column]}`);
    }
    return keys;
}

function coordinate(key) {
    const split = key.indexOf(':');
    return {lineId: key.slice(0, split), date: key.slice(split + 1)};
}

module.exports = {rectangleKeys, coordinate};
